import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Dropdown,
  FormControl,
  FormSelect,
  Table,
} from 'react-bootstrap'
import Pagination from '../../reusable/Pagination'
import Delete from './Delete'
import fetchData from '../../utils/fetchData'
import formatDate from '../../utils/formatDate'
import getCookie from '../../utils/getCookie'
import { staticUrl } from '../../utils/url'
import Add from './Add'

const Team = () => {
  // ! hooks
  const [isModal, setModal] = useState(false)
  const [isEdit, setEdit] = useState(false)
  const [teams, setTeams] = useState([])
  const [teamData, setTeamData] = useState()
  const [isDelete, setDelete] = useState(false)
  const [id, setId] = useState()
  // ! filter
  const [filter, setFilter] = useState({ search: '', status: '' })
  // ! pagination
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [limit, setLimit] = useState(10)

  // ! get teams data
  const getTeams = async () => {
    try {
      const { data } = await fetchData.get(
        `/team?page=${page}&limit=${limit}&filter=${JSON.stringify(filter)}`,
        { headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` } }
      )
      setTotal(data?.total)
      setTeams(data?.teams)
    } catch (error) {
      console.log({ ...error }, error)
    }
  }
  useEffect(() => {
    getTeams()
  }, [page, limit, filter])
  useEffect(() => {
    setPage(1)
  }, [filter])

  return (
    <section className='content-wrapper'>
      <Add
        isModal={isModal}
        setModal={setModal}
        isEdit={isEdit}
        setEdit={setEdit}
        setTeamData={setTeamData}
        teamData={teamData}
        getTeams={getTeams}
      />
      <Delete
        isModal={isDelete}
        setModal={setDelete}
        id={id}
        setId={setId}
        getTeams={getTeams}
      />
      <Card className='mb-4'>
        <Card.Body>
          <div className='d-flex flex-wrap align-items-center justify-content-between'>
            <Card.Title>Teams</Card.Title>
            <div className='mb-3'>
              <Button size='sm' onClick={() => setModal(true)}>
                <i className='mdi mdi-plus me-1'></i> Add
              </Button>
            </div>
          </div>
          <div className='filter'>
            <div>
              <FormControl
                type='text'
                placeholder='Search'
                autoComplete='off'
                name='search'
                value={filter.search}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }
              />
            </div>
            <div>
              <FormSelect
                autoComplete='off'
                name='status'
                value={filter.status}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }>
                <option value=''>All</option>
                <option value='true'>Visible</option>
                <option value='false'>Hidden</option>
              </FormSelect>
            </div>
          </div>
          <Table responsive>
            <thead>
              <tr>
                <th scope='col'>Team</th>
                <th scope='col' style={{ minWidth: '35rem' }}>
                  Description
                </th>
                <th scope='col'>Status</th>
                <th scope='col'>Joined On</th>
                <th
                  scope='col'
                  style={{ maxWidth: '3rem', width: '3rem' }}></th>
              </tr>
            </thead>
            <tbody>
              {teams?.map((team) => (
                <tr key={team?._id}>
                  <td className='align-middle text-nowrap'>
                    <div className='table-img'>
                      <img
                        src={
                          team?.avatar
                            ? staticUrl + team?.avatar
                            : '/assets/images/team-1.png'
                        }
                        alt={team?.name}
                      />
                      <div>
                        <h6>{team?.name}</h6>
                        <p>{team?.position}</p>
                      </div>
                    </div>
                  </td>
                  <td className='align-middle'>
                    <p className='table-description'>{team?.description}</p>
                  </td>
                  <td className='align-middle'>
                    {team?.status ? (
                      <span className='status status-outline-success'>
                        Visible
                      </span>
                    ) : (
                      <span className='status status-outline-danger'>
                        Hidden
                      </span>
                    )}
                  </td>
                  <td className='align-middle text-nowrap'>
                    {formatDate({ date: team?.joinedOn })}
                  </td>
                  <td className='align-middle text-center'>
                    <Dropdown>
                      <Dropdown.Toggle as='span' className='pnt'>
                        <i className='mdi mdi-dots-vertical'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          as='span'
                          className='pnt'
                          onClick={() => {
                            setEdit(true)
                            setModal(true)
                            setTeamData(team)
                          }}>
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          as='span'
                          className='pnt'
                          onClick={() => {
                            setDelete(true)
                            setId(team?._id)
                          }}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
            page={page}
            setPage={setPage}
            total={total}
            limit={limit}
          />
        </Card.Body>
      </Card>
    </section>
  )
}

export default Team
